import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Jälgimisnimekiri", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_3 = { class: "col-2 p-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-6 p-2" }
const _hoisted_6 = { class: "small" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-2 p-2" }
const _hoisted_9 = { class: "col-2 p-2 text-right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    (_ctx.errorMsg != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getWatchlist(), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "border row"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.getProductImageByBarcode(item.product.barcode),
            alt: "",
            height: "64"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RouterLink, {
            to: { name: 'product-details', params: { id: item.productId } },
            class: "text-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.product.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(item.product.barcode) + " ", 1),
            _createElementVNode("button", {
              class: "border-0 small",
              onClick: ($event: any) => (_ctx.clickRemove(item.id))
            }, "x", 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createVNode(_component_RouterLink, {
              to: { name: 'product-details', params: { id: item.productId } },
              class: "text-dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" €" + _toDisplayString(item.product.minPrice), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.addAlarm(item.productId)),
            class: "border-0",
            style: _normalizeStyle({backgroundColor: _ctx.alarmIsActive(item.productId) ? 'green' : 'lightgray'})
          }, _hoisted_12, 12, _hoisted_10)
        ])
      ]))
    }), 128))
  ], 64))
}